module.exports = __webpack_public_path__ + "img/DW365-171.9eae628d.jpg";